export const MAIN_STEP = 'mainStep';
export const STUDENTS_LIST_STEP = 'studentsListStep';
export const PROPERTIES_STEP = 'propertiesStep';
export const CREATE_EXTENSION_STEP = 'createExtensionStep';
